/* eslint-disable */
import { Box, Card, useTheme } from "@mui/material";
import GoogleIndia from "./GoogleIndia";
import KeywordFeatureTable from "./KeywordFeatureTable";

function GoogleAndKeywordFeatureTable({
  rankingData,
  dropDownValue,
  setDropDownValue,
  search,
  setSearch,
  checkedRows,
  handleCheckboxChange,
  countActiveIcons,
  setMaxActiveIcons,
  maxActiveIcons,
  modelOpen,
  setModelOpen,
  handleDelete,
  queryObj,
  setQueryObj,
}) {
  const theme = useTheme();
  return (
    <Box>
      <GoogleIndia rankingData={rankingData} checkedRows={checkedRows} maxActiveIcons={maxActiveIcons} />
      <Card sx={{ padding: { xs: "16px 10px 24px 10px", sm: "16px 24px 24px 24px" }, mt: "15px", border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
        <KeywordFeatureTable
          rankingData={rankingData}
          dropDownValue={dropDownValue}
          setDropDownValue={setDropDownValue}
          search={search}
          setSearch={setSearch}
          handleCheckboxChange={handleCheckboxChange}
          countActiveIcons={countActiveIcons}
          setMaxActiveIcons={setMaxActiveIcons}
          modelOpen={modelOpen}
          setModelOpen={setModelOpen}
          handleDelete={handleDelete}
          queryObj={queryObj}
          setQueryObj={setQueryObj}
        />
      </Card>
    </Box>
  );
}

export default GoogleAndKeywordFeatureTable;
